import {Injectable} from "@angular/core";
import {OrderRepository} from "../../core/orders/order-repository";
import {CombinedOrderElementDto} from "../../../models/core/combined-order-element-dto";


@Injectable({
  providedIn: 'root'
})
export class CategoryRevenueRepository {
  categoryRevenue: { [K in keyof CombinedOrderElementDto]: { id: string, revenue: number } [] } = {
    revenueAfterTax: [],
    eventId: [],
    locationId: [],
    bookingType: [],
    compositionTypeId: [],

    // dont use those
    interval: [], orderCount: [], revenue: [], sourceDetailsCost: []
  }

  isUpToDate: { [id: string]: boolean } = {}

  /*categoryNameMapping: {[K in keyof CombinedOrderElementDto]: {[id: string]: string}} = {
    revenueAfterTax: {},
    eventId: {},
    locationId: {},
    bookingType: {},
    compositionTypeId: {},
    // dont use those
    interval: {}, orderCount: {}, revenue: {}
  }*/

  setCategoryRevenue<T extends keyof CombinedOrderElementDto>(categoryKey: T, data: { id: string, revenue: number }[]) {
    this.categoryRevenue[categoryKey] = data;
  }

  /*setCategoryNameMapping<T extends keyof CombinedOrderElementDto>(categoryKey: T, data: {[id: string]: string}) {
    this.categoryNameMapping[categoryKey] = data;
  }*/

  constructor(private orderRepository: OrderRepository) {
  }

  update() {
    this.isUpToDate = {}
  }

  updateCategoryRevenue(categoryKey: keyof CombinedOrderElementDto, revenueFn: (combinedOrderElementDto: CombinedOrderElementDto) => number) {
    if (this.isUpToDate[categoryKey as string] === undefined || !this.isUpToDate[categoryKey as string]) {
      let revenues: {
        id: string,
        revenue: number
      }[] = CategoryRevenueRepository.calculateCategoryRevenue(this.orderRepository.getActiveOrderElements(), categoryKey, revenueFn)
      this.setCategoryRevenue(categoryKey as keyof CombinedOrderElementDto, revenues)
    }

  }

  static calculateCategoryRevenue(activeOrderElements: CombinedOrderElementDto[], categoryKey: keyof CombinedOrderElementDto, revenueFn: (combinedOrderElementDto: CombinedOrderElementDto) => number) {
    let revenuesPerCategory: { [id: string]: number } = {}
    for (let combinedOrderElement of activeOrderElements as CombinedOrderElementDto[]) {
      let key = combinedOrderElement[categoryKey as keyof CombinedOrderElementDto] as string
      if (revenuesPerCategory[key] === undefined) {
        revenuesPerCategory[key] = 0
      }
      revenuesPerCategory[key] += revenueFn(combinedOrderElement)
    }

    let revenues: { id: string, revenue: number }[] = Object.keys(revenuesPerCategory).map(id => ({
      id: id,
      revenue: revenuesPerCategory[id]
    }));

    revenues.sort((a, b) => {
      return b.revenue - a.revenue
    })

    return revenues
  }
}
